// @ts-strict-ignore
import { ArticleRefreshData } from '@article/service/model/article-refresh-data';
import { ContainerService } from '@3d-scene/model3d/container.service';
import { ComplexProjectVO, ProjectVO } from '../model/vo/project.vo';
import { ArticleContainerLoader } from '@article/service/article-container-loader';
import { WireBridgeService } from '../components/article/manager/wire-bridge.service';
import { ProjectModel } from '../model/project.model';
import { CompositeArticleManager } from '@article/manager/composite-article.manager';
import { ArticleManager } from '@article/manager/article.manager';
import { PropertyVO } from '../components/article/model/vo/property.vo';
import { StringUtils } from '@shared/util/string-utils';
import { NumberUtils } from '@shared/util/number-utils';
import { ArticleVO } from '@article/model/vo/article.vo';
import { Injectable } from '@angular/core';
import { InsertArticleService } from '../components/article/service/insert-article.service';
import { ArticleContainerUtils } from '@3d-scene/model3d/util/article-container-utils';
import { DetachArticleUsageService } from './detach-article-usage.service';

@Injectable({ providedIn: 'root' })
export class LoadProjectArticlesService {

  constructor(
    private projectModel: ProjectModel,
    private articleContainerLoader: ArticleContainerLoader,
    private wireBridgeService: WireBridgeService,
    private compositeArticleManager: CompositeArticleManager,
    private articleManager: ArticleManager,
    private containerService: ContainerService,
    private _insertArticleService: InsertArticleService,
    private detachArticleUsageService: DetachArticleUsageService
  ) {}

  public async loadProjectArticles(complexProjectVO: ComplexProjectVO, isCompositeArticle: boolean = false): Promise<void> {
    const refreshData: ArticleRefreshData = new ArticleRefreshData();
    refreshData.dynamicArticlesMap = complexProjectVO.dynamicArticlesMap;
    refreshData.dynamicArticlesInfo = complexProjectVO.project.dynamicArticlesInfo ? complexProjectVO.project.dynamicArticlesInfo.concat() : null;
    refreshData.isArticleRepresentationsEnabled = this.projectModel.isArticleRepresentationsEnabled(complexProjectVO.project);
    refreshData.updateTextures = false;
    refreshData.deleteUnusedConnections = !isCompositeArticle;

    try {
      await this.articleContainerLoader.refreshContainers(this.containerService.enumerateArticleContainersInGlobal(), refreshData);
    } catch (error) {
      this.detachArticleUsageService.detachArticleUsageFromProjectByIds(ArticleContainerUtils.extractArticleGUIDs(this.containerService.enumerateArticleContainersInGlobal()));
      throw error;
    }
    this.wireBridgeService.createJumpersWhileLoadingProject();
    this._insertArticleService.markAllArticlesLoaded();
  }

  public async setArticleInfos(complexProjectVO: ComplexProjectVO) {
    this.compositeArticleManager.addCompositeArticleProjects(complexProjectVO.compositeArticleProjectsMap, complexProjectVO.project.projectType);
    complexProjectVO.project.isArticleProject = complexProjectVO.isArticleProject;
    complexProjectVO.project.isWSPImportedProject = complexProjectVO.isWSPImportedProject;

    await this.articleManager.addArticlesToCache(complexProjectVO.articles);
  }

  public updateInfoProperties(project: ProjectVO) {
    if (!project) {
      return;
    }
    const mcsGdsInitArticleNo: PropertyVO = project.infoProperties.getSingle("mcsGdsInitArticleNo");
    if (mcsGdsInitArticleNo && mcsGdsInitArticleNo.values && mcsGdsInitArticleNo.values.length < 1) {
      const articleNo: string = project.articleNumber;
      if (!StringUtils.isEmpty(articleNo)) {
        project.infoProperties.setString("mcsGdsInitArticleNo", articleNo);
      } else {
        const mcsGdsInitArticleId: number = project.infoProperties.getInt("mcsGdsInitArticleId");
        let mcsGdsInitArticleVersion: number = project.infoProperties.getInt("mcsGdsInitArticleVersion");
        if (NumberUtils.isNumber(mcsGdsInitArticleId)) {
          if (NumberUtils.isNotNumber(mcsGdsInitArticleVersion)) {
            mcsGdsInitArticleVersion = -1;
          }
          const articleVO: ArticleVO = this.articleManager.getCachedArticle(mcsGdsInitArticleId, mcsGdsInitArticleVersion);
          if (articleVO) {
            project.infoProperties.setString("mcsGdsInitArticleNo", articleVO.articleNo);
          }
        }
      }
    }
  }
}
